// extracted by mini-css-extract-plugin
export default {"card":"lZ-z","carouselContainer":"mZ-z","carouselContent":"nZ-z"};